import "./App.css"; 
import { Analytics } from "@vercel/analytics/react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AdConsentProvider } from "./ads/adConsent";
import AdminRoute from "./AdminRoute";
import AdminUsersView from "./AdminUsersView";
import BrowseCardsView from "./BrowseCardsView";
import BrowseUsersView from "./BrowseUsersView";
import CookiePolicyView from "./CookiePolicyView";
import LegalFooter from "./LegalFooter";
import LegalOverviewView from "./LegalOverviewView";
import PrivacyPolicyView from "./PrivacyPolicyView";
import Navigation from "./Navigation";

import AuthView from "./AuthView";
import ForgotPasswordView from "./ForgotPasswordView";
import GeneralSettingsView from "./GeneralSettingsView";
import HomeView from "./HomeView";
import ProtectedRoute from "./ProtectedRoute";
import ResetPasswordView from "./ResetPasswordView";
import TradeFinderView from "./TradeFinderView";
import MyAccountView from "./MyAccountView";
import MyMessagesView from "./MyMessagesView";
import TradeFinderSettingsView from "./TradeFinderSettingsView";
import MyTradersSettingsView from "./MyTradersSettingsView";
import MyWantsSettingsView from "./MyWantsSettingsView";
import TradeHistoryView from "./TradeHistoryView";
import PricingCurrencyView from "./PricingCurrencyView";
import TermsOfServiceView from "./TermsOfServiceView";
import VerifyEmailView from "./VerifyEmailView";
import MyTradersView from "./MyTradersView";
import MyWantsView from "./MyWantsView";

function App() {
  return (
    <AdConsentProvider>
      <Router>
        <div className="app-shell">
          {/* Navigationen ligger uden for Routes, så den er synlig på alle sider. */}
          <Navigation />

          <main className="app-shell__content">
            {/* Appen er lille nok til at routing stadig kan overskues centralt her. */}
            <Routes>
              <Route path="/" element={<HomeView />} />
              <Route path="/auth" element={<AuthView />} />
              <Route path="/auth/forgot-password" element={<ForgotPasswordView />} />
              <Route path="/auth/reset-password" element={<ResetPasswordView />} />
              <Route path="/auth/verify-email" element={<VerifyEmailView />} />
              <Route path="/admin" element={<AdminRoute><AdminUsersView /></AdminRoute>} />
              <Route path="/browse" element={<ProtectedRoute><Navigate to="/browse/users" replace /></ProtectedRoute>} />
              <Route path="/browse/cards" element={<ProtectedRoute><BrowseCardsView /></ProtectedRoute>} />
              <Route path="/browse/cards/:browseCardName" element={<ProtectedRoute><BrowseCardsView /></ProtectedRoute>} />
              <Route path="/browse/users" element={<ProtectedRoute><BrowseUsersView /></ProtectedRoute>} />
              <Route path="/browse/users/:browseUserRef" element={<ProtectedRoute><BrowseUsersView /></ProtectedRoute>} />
              <Route path="/tradefinder" element={<ProtectedRoute requireTradeFinderLocation><TradeFinderView /></ProtectedRoute>} />
              <Route path="/account/general-settings" element={<ProtectedRoute><GeneralSettingsView /></ProtectedRoute>} />
              <Route path="/account/tradefinder-settings" element={<ProtectedRoute><TradeFinderSettingsView /></ProtectedRoute>} />
              <Route path="/account/my-traders-settings" element={<ProtectedRoute><MyTradersSettingsView /></ProtectedRoute>} />
              <Route path="/account/my-wants-settings" element={<ProtectedRoute><MyWantsSettingsView /></ProtectedRoute>} />
              <Route path="/account/trade-history" element={<ProtectedRoute><TradeHistoryView /></ProtectedRoute>} />
              <Route path="/account/pricing-and-currency" element={<ProtectedRoute><PricingCurrencyView /></ProtectedRoute>} />
              <Route path="/account/messages" element={<ProtectedRoute><MyMessagesView /></ProtectedRoute>} />
              <Route path="/account" element={<ProtectedRoute><MyAccountView /></ProtectedRoute>} />
              <Route path="/traders" element={<ProtectedRoute><MyTradersView /></ProtectedRoute>} />
              <Route path="/wants" element={<ProtectedRoute><MyWantsView /></ProtectedRoute>} />
              <Route path="/legal" element={<LegalOverviewView />} />
              <Route path="/terms" element={<TermsOfServiceView />} />
              <Route path="/privacy" element={<PrivacyPolicyView />} />
              <Route path="/cookies" element={<CookiePolicyView />} />
            </Routes>
          </main>

          <LegalFooter />
          <Analytics />
        </div>

      </Router>
    </AdConsentProvider>
  );
}

export default App;
